import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_ALLERGEN_EXCLUDED_INGREDIENTS_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateAllergenIncludedIngredientsDetailsArgs } from '../graphql/transformers'
import { UPDATE_ALLERGEN_EXCLUDED_INGREDIENTS_DETAILS } from '../redux/action-types'

const useUpdateAllergenIncludedIngredientsDetailsMutation = () => {
  const dispatch = useDispatch()

  const {
    isIncludedIngredientsDetailsLoading,
    includedIngredientsDetailsError,
  } = useSelector(store => store.allergens.allergen)

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_ALLERGEN_EXCLUDED_INGREDIENTS_DETAILS_MUTATION,
        {
          id,
          data: transformToUpdateAllergenIncludedIngredientsDetailsArgs(data),
        },
        dispatch,
        UPDATE_ALLERGEN_EXCLUDED_INGREDIENTS_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    {
      isLoading: isIncludedIngredientsDetailsLoading,
      error: includedIngredientsDetailsError,
    },
  ]
}

export default useUpdateAllergenIncludedIngredientsDetailsMutation
